import SectionWithExpand from './SectionWithExpand'

export default SectionWithExpand
